import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { ExternalMinor } from '@shopify/polaris-icons'

interface Props {
  url: string
}

const LmsTrainingLinkCellComponent = ({ url }: Props) => {
  const trimmedUrl = url?.trim()

  if (!trimmedUrl) {
    // A dash for a missing value is a cosmetic default, not fabricated content.
    return (
      <Typography variant="body2" css={tw`text-shades-500`}>
        —
      </Typography>
    )
  }

  return (
    // A real `href` is what makes this keyboard-focusable; `rel` because the target is an
    // arbitrary third-party LMS origin.
    <a
      href={trimmedUrl}
      target="_blank"
      rel="noopener noreferrer"
      css={tw`text-primary-500 inline-flex flex-row items-center gap-1 no-underline hover:underline`}
    >
      <Typography variant="body2" css={tw`text-primary-500`}>
        Open
      </Typography>
      <ExternalMinor width={14} css={tw`fill-primary-500`} />
    </a>
  )
}

export const LmsTrainingLinkCell = memo(LmsTrainingLinkCellComponent)
